import React, {Component} from 'react';
import './global.css';
import NavBar from './NavBar';
import PageFooter from './PageFooter';

class About extends Component {
    render() {
        return <div className="container">
            <NavBar navigate={this.props.navigate} current='About' />
            <br/>
            <p className="normal">
                <h1>About <strong>AnswerSolutions LLC</strong></h1>
            </p>
            <br/>
            <div className="card" id="shellWhite">
                <div id="content">
                    <p className="normal"><h2>Who we are</h2></p>
                    <p>
                        AnswerSolutions LLC is an independent software company focused on building simple,
                        reliable communication tools for everyday people and professionals. We are a small,
                        remote-first team passionate about making phone-based workflows easier — whether
                        you are an attorney, a journalist, a recruiter, or simply someone who wants to
                        remember an important conversation.
                    </p>
                </div>
            </div>
            <br/>
            <div className="card" id="shellWhite">
                <div id="content">
                    <p className="normal"><h2>What we make</h2></p>
                    <p>
                        Our flagship product, <b>A Call Recorder</b>, lets you record incoming and outgoing
                        phone calls on iPhone and Android using a three-way calling technique — no special
                        hardware, no desktop app, no jailbreak required.
                    </p>
                    <p>
                        We pair recording with <b>AI-powered transcription</b> so you can turn any recorded
                        conversation into a readable, searchable text document. Transcription works for most
                        languages; it has been primarily tested for the most common languages in the US and Canada.
                    </p>
                </div>
            </div>
            <br/>
            <div className="card" id="shellWhite">
                <div id="content">
                    <p className="normal"><h2>Our principles</h2></p>
                    <ul>
                        <li><b>Transparency.</b> Both parties hear a recording announcement at the start of every call. We believe recorded calls should always be disclosed.</li>
                        <li><b>Fair pricing.</b> Pay only for what you use — no subscriptions, no hidden fees, no expiring credits.</li>
                        <li><b>Privacy first.</b> We store your recordings and transcriptions in the cloud only as long as you need them. You can delete everything at any time.</li>
                        <li><b>Quality over quantity.</b> We use carrier-grade IVR infrastructure and best-in-class ML/AI engines to deliver the highest possible audio and transcription quality.</li>
                    </ul>
                </div>
            </div>
            <br/>
            <div className="card" id="shellWhite">
                <div id="content">
                    <p className="normal"><h2>Get in touch</h2></p>
                    <p>
                        Questions, feedback, or partnership inquiries — we read every email.
                    </p>
                    <ul>
                        <li>General support: <a href="mailto:support@answersolutions.net">support@answersolutions.net</a></li>
                        <li>Feedback &amp; suggestions: <a href="mailto:feedback@answersolutions.net">feedback@answersolutions.net</a></li>
                        <li>Sales &amp; volume pricing: <a href="mailto:sales@answersolutions.net">sales@answersolutions.net</a></li>
                    </ul>
                </div>
            </div>
            <br/>
            <PageFooter navigate={this.props.navigate} current='About' />
            <br/>
        </div>
    }
}

export default About;
